import * as React from 'react';
import { FileUpload, FileUploadItem, TextItem, typeCompact12Medium } from '@traceair/tds';
import { stylesheet } from 'typestyle';

type Props = {
  file?: File;
  isUploading: boolean;
  uploadedLink?: string;
  isError: boolean;
  onFileChange: (file: File | undefined) => void;
};

const st = stylesheet({
  description: {
    display: 'flex',
    flexDirection: 'column',
  },
});

export const UploadInvoiceSection: React.FC<Props> = ({ file, isUploading, uploadedLink, isError, onFileChange }) => {
  if (file) {
    return (
      <FileUploadItem
        disabled={isUploading}
        file={{
          uid: file.name,
          name: file.name,
          size: file.size,
          type: file.type,
          status: isUploading ? 'uploading' : uploadedLink ? 'done' : 'error',
        }}
        onRemove={() => onFileChange(undefined)}
        onRetry={() => onFileChange(file)}
      />
    );
  }

  return (
    <FileUpload
      fileFormatIcons={['pdf']}
      accept="application/pdf,.pdf"
      description={
        <div className={st.description}>
          <TextItem text="Preferred formats: PDF" style={typeCompact12Medium} />
        </div>
      }
      multiple={false}
      showUploadList={false}
      disabled={isUploading}
      isError={isError}
      errorMessage={<TextItem text="Upload an invoice" style={typeCompact12Medium} />}
      onChange={(info) => {
        const f = info.file.originFileObj;
        if (f) onFileChange(f);
      }}
    />
  );
};
